module.exports = __webpack_public_path__ + "img/feature-1-new-york.a585f76e.png";